<template>
  <div class="diadin">
  
    <div class="bonntbot">

      <div style="display: flex; justify-content: flex-end; width: 100%;">
        <el-button type="text" @click="exportMyTransactionLoga">{{ $t('menu.Export') }}</el-button>

      </div>
    </div>

    <div style="display: flex;">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input style="width: 300px;"
          clearable
            :placeholder="`${$t('menu.TransactionSerialNumber')}/${$t('menu.TransactionOrderNumber')}`"
            v-model="formInline.title"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.category" :placeholder="$t('menu.TransactionType')" clearable>
            <el-option :label="$t('menu.All')" value=" "></el-option>
            <el-option v-if="in8l == 'zh'" v-for="(item, index) in accTransactionTypeList " :key="index"
              :label="item.name" :value="item.id"></el-option>
            <el-option v-if="in8l !== 'zh'" v-for="(item, index) in accTransactionTypeList " :key="index"
              :label="item.nameEn" :value="item.id"></el-option>


          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="value1" type="daterange" @change="aaccc" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" :range-separator="$t('menu.to')" :start-placeholder="$t('menu.Startdata')"
            :end-placeholder="$t('menu.Enddata')">
          </el-date-picker>
        </el-form-item>

        <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button>
      </el-form>
    </div>
    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
      <el-table-column prop="transactionNumber" :label="$t('menu.TransactionSerialNumber')"
        width="220"></el-table-column>
      <el-table-column prop="orderNumber" :label="$t('menu.TransactionOrderNumber')" width="220"> </el-table-column>
      <el-table-column prop="transactionTypeId" :label="$t('menu.TransactionType')" width="210">
        <template slot-scope="scope">
          <div>
            {{ formatAccTransactionType(scope.row.transactionTypeId) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="amount" :label="$t('menu.IncomeAndExpenditureTypes')" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.amount < 0">
            {{ $t('menu.Expense') }}
          </div>
          <div v-else>  {{ $t('menu.Income') }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="amount" :label="$t('menu.Currency')" width="120">
        <template slot-scope="scope">
          {{ formatAccTransactionTypea(scope.row.transactionTypeId) }}
        </template>
      </el-table-column>
       <el-table-column prop="amount" :label="$t('menu.AmountChanges')" width="120">
       
      </el-table-column>
      <el-table-column prop="comment" :label="$t('menu.Remarks')" width="120">

      </el-table-column>

      <el-table-column prop="operationTime" :label="$t('menu.Time')">
        <template slot-scope="scope">
          <div>
            {{ fotmartTime(scope.row.operationTime) }}
          </div>
        </template>
      </el-table-column>

    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, prev, pager, next" :total="total">
      </el-pagination>

    </div>

    <div></div>
  </div>
</template>

<script>
import { accmyAccLog, myAcc, listAccType, listAccTransactionType, exportMyTransactionLog } from "../../api/api";

export default {
  props:['accTypeId'],
  data () {
    return {
      myAcclist: [],
      
      action: 0,
      activeName: '0',
      currentPage3: 1,
      pagesize: 10,
      totale: 0,
      activeName: "first",
      mation: [], //列表
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
      accTypeList: [],
      accTransactionTypeList: [],
      value1: '',
      in8l: 'zh',
    };
  },

  created () {
    let a = sessionStorage.getItem('i18n')
    this.in8l = a
    // this.myacc()
    this.biao();
    
    this.getTypeList()
    this.getListAccTransactionType()
    // this.exportMyTransactionLoga()
  },
  methods: {
    async exportMyTransactionLoga () {



      let data = {}
      let c = this.accTypeId
      let a = 1

      console.log(a);


      await exportMyTransactionLog(data, c).then(res => {
        if (a == 1) {
          a++
          // 创建一个URL对象，将Blob对象包装成一个临时的可访问URL
          const url = window.URL.createObjectURL(new Blob([res.data]));
          // 创建一个<a>元素，用于模拟点击下载文件
          const link = document.createElement('a');
          link.href = url;
          // 设置下载文件的名称
          link.setAttribute('download', '流水.xlsx');
          // 将<a>元素添加到文档中
          document.body.appendChild(link);
          // 模拟点击下载
          link.click();
          // 移除<a>元素
          // link.remove();
          // 释放创建的URL对象，避免内存泄漏
          window.URL.revokeObjectURL(url);


        }

      })
    },

    aaccc (e) {
      console.log(e, this.value1);

    },
    fotmartTime (str) {
      let time = str.replace('T', ' ')
      return time
    },
    async getTypeList () {
      await listAccType().then(r => {
        this.accTypeList = r.data.data
      })
    },
    flstusts (value) {
      let that = this
      let a = that.accTypeList
      let b = ''
      a.forEach(e => {
        if (e.id == value && this.in8l == 'zh') {
          b = e.name
        }
        if (e.id == value && this.in8l !== 'zh') {
          b = e.nameEn
        }

      })
      return b;
    },
    async getListAccTransactionType () {
      await listAccTransactionType().then(r => {
        this.accTransactionTypeList = r.data.data
      })
    },
    formatAccTransactionType (id) {
      let name = ''
      this.accTransactionTypeList.forEach(item => {
        if (item.id == id && this.in8l == 'zh') {
          name = item.name
        }
        if (item.id == id && this.in8l !== 'zh') {
          name = item.nameEn
        }
      })
      return name
    },
    formatAccTransactionTypea (id) {
      let accTypeId = ''
      this.accTransactionTypeList.forEach(item => {
        if (item.id == id) {
          accTypeId = item.accTypeId
        }
      })
      // console.log(123,accTypeId);
      let name = ''
      this.accTypeList.forEach(item => {
        if (item.id == accTypeId) {
          name = item.currencyType
        }
      })
      // this.formatType(accTypeId)
      return name
    },
    formatType (id) {
      let name = ''
      this.accTypeList.forEach(item => {
        if (item.id == id) {
          name = item.currencyType
        }
      })
      return name
    },
    async myacc () {
      let param = new URLSearchParams();
      const { data: res } = await myAcc(param);
      this.myAcclist = res.data.accs;
      res.data.accs.forEach((e, i) => {
        this.myAcclist[i].ty = 'hover'
      });
      this.myAcclist[0].ty = 'always'
      this.accTypeId = this.myAcclist[0].id
      this.biao()
    },
    tabacc (i) {
      let a = this.myAcclist
      a.forEach((e, z) => {
        a[z].ty = 'hover'
      });
      a[i].ty = 'always'

      this.accTypeId = this.myAcclist[i].id
      this.currentPage3 = 1
      this.biao()
      this.myAcclist = []
      this.myAcclist = a
    },
    search () {
      this.biao()
    },
    async biao () {
      let param = new URLSearchParams();
      let accTypeId =  this.accTypeId
      let startDateTime = ''
      let endDateTime = ''
      if (this.value1.length > 0) {
        startDateTime = this.value1[0]
        endDateTime = this.value1[1]
      }
      const { data: res } = await accmyAccLog(
        param,
        accTypeId,
        this.currentPage3,
        this.pagesize,
        this.formInline.title,
        this.formInline.category,
        startDateTime,
        endDateTime
      );

      this.mation = res.data.list;
      this.total = res.data.total
    },
    handleClick (tab, event) {
      console.log(tab, event);
    },
    //表单点击

    handleEdit (index, row) {
      this.$router.push({
        path: "/ordercontent",
        query: {
          vin: row.vin,
          type: index,
        },
      });
    },


    //搜索
    onSubmit () {
      this.biao();
    },


    handleSizeChange (val) {

      this.pagesize = val
      console.log(`每页 ${val} 条`);
      this.biao();
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.biao();
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.topbox {
  display: flex;
  width: 100%;
  // margin-bottom: 20px;
}

.bonntbot {
  // padding-bottom: 20px;
  border-bottom: 1px solid #d7d7d7;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}


/deep/.el-table th.is-leaf {
  text-align: left;

}

.fs {
  font-size: 28px;
  color: #000;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
}

.topbox1 {

  font-size: 18px;
  color: #909399;

}
</style>